import ReactDOMServer from 'react-dom/server'

const plotToHtml = component => {
  return ReactDOMServer.renderToStaticMarkup(component)
}

export default plotToHtml
